import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import usePageAnalytics from "@/hooks/usePageAnalytics";

import Home from "@/pages/Home";
import { Design, Consult, Learn } from "@/pages/Services";
import Work from "@/pages/Work";
import WorkDetail from "@/pages/WorkDetail";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    usePageAnalytics();
    useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
};

const Shell = ({ children, hideChrome }) => (
    <>
        {!hideChrome && <Navigation />}
        {children}
        {!hideChrome && <Footer />}
        {!hideChrome && <WhatsAppFloat />}
    </>
);

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Shell><Home /></Shell>} />
                        <Route path="/design" element={<Shell><Design /></Shell>} />
                        <Route path="/consult" element={<Shell><Consult /></Shell>} />
                        <Route path="/learn" element={<Shell><Learn /></Shell>} />
                        <Route path="/work" element={<Shell><Work /></Shell>} />
                        <Route path="/work/:slug" element={<Shell><WorkDetail /></Shell>} />
                        <Route path="/about" element={<Shell><About /></Shell>} />
                        <Route path="/blog" element={<Shell><Blog /></Shell>} />
                        <Route path="/blog/:slug" element={<Shell><BlogPost /></Shell>} />
                        <Route path="/contact" element={<Shell><Contact /></Shell>} />
                        <Route path="/admin/login" element={<Shell hideChrome><AdminLogin /></Shell>} />
                        <Route path="/admin" element={<Shell hideChrome><AdminDashboard /></Shell>} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
